
var viz;

var Visualization = function () {

  // references
  this.root = '';
  this.context = '';

  this.pulseIndex = 0;
  this.pulseShrink = false;

  this.ms = { x: 0, y: 0 }; // Mouse speed
  this.mp = { x: 0, y: 0 }; // Mouse position

  this.init = function (divID) {
    this.pulseImage = new Image();
    this.pulseImage.src = "/Trainer/images/getStarted/glow.png";

    var el = document.getElementById(divID);

    // need to update the canvas element's CSS properties
    this.canvasWidth = el.width;
    this.canvasHeight = el.height;

    this.root = el;
    window.ctx = el.getContext("2d");

    // set origin point
    this.origin = new Vector2D(this.canvasWidth / 2, this.canvasHeight / 4);

    // initiate particle system with a single particle
    this.ps = new ParticleSystem(0, this.origin);

    // draw loop
    this.timeUpdateInterval = setInterval(draw, 20);

    var small = 0.5;
    var medium = 0.75;
    var large = 1;

    // keep adding new particles
    //this.addParticleInterval = setInterval("viz.ps.addParticle(viz.ps.origin.x,viz.ps.origin.y)",10);
    viz.ps.addParticle(216, 61, 0, medium);
    viz.ps.addParticle(232, 73, 20, medium);
    viz.ps.addParticle(243, 68, 25, large);
    viz.ps.addParticle(260, 74, 30, medium);
    viz.ps.addParticle(247, 89, 35, large);
    viz.ps.addParticle(221, 93, 40, medium);
    viz.ps.addParticle(258, 97, 45, small);
    viz.ps.addParticle(234, 107, 50, medium);
    viz.ps.addParticle(263, 107, 55, large);
    viz.ps.addParticle(219, 116, 60, small);
    viz.ps.addParticle(244, 118, 65, medium);
    viz.ps.addParticle(223, 127, 70, large);
    viz.ps.addParticle(238, 135, 75, small);
    viz.ps.addParticle(212, 145, 80, medium);
    viz.ps.addParticle(198, 131, 85, medium);
    viz.ps.addParticle(196, 154, 90, small);
    viz.ps.addParticle(182, 150, 95, medium);
    viz.ps.addParticle(177, 135, 100, small);
    viz.ps.addParticle(169, 164, 105, large);
    viz.ps.addParticle(165, 143, 110, large);
    viz.ps.addParticle(154, 149, 115, medium);
    viz.ps.addParticle(143, 168, 120, medium);
    viz.ps.addParticle(139, 137, 125, medium);
    viz.ps.addParticle(132, 150, 130, medium);
    viz.ps.addParticle(119, 164, 135, large);
    viz.ps.addParticle(115, 143, 140, large);
    viz.ps.addParticle(104, 149, 145, medium);
    viz.ps.addParticle(95, 135, 150, small);
    viz.ps.addParticle(93, 167, 155, medium);
    viz.ps.addParticle(88, 147, 160, large);
    viz.ps.addParticle(76, 154, 165, small);
    viz.ps.addParticle(67, 160, 170, medium);
    viz.ps.addParticle(75, 131, 175, medium);
    viz.ps.addParticle(60, 145, 180, medium);
    viz.ps.addParticle(42, 145, 185, medium);
    viz.ps.addParticle(49, 127, 190, large);
    viz.ps.addParticle(34, 134, 195, small);
    viz.ps.addParticle(53, 116, 200, small);
    viz.ps.addParticle(17, 131, 205, large);
    viz.ps.addParticle(28, 118, 210, medium);
    viz.ps.addParticle(37, 107, 215, medium);
    viz.ps.addParticle(10, 107, 220, large);
    viz.ps.addParticle(14, 97, 225, small);
    viz.ps.addParticle(52, 93, 230, medium);
    viz.ps.addParticle(26, 89, 235, large);
    viz.ps.addParticle(12, 74, 240, medium);
    viz.ps.addParticle(30, 68, 245, large);
    viz.ps.addParticle(41, 73, 250, medium);
    viz.ps.addParticle(56, 61, 255, medium);
  }
}

function pulse() {
  if (viz.pulseIndex > 0) {
    ctx.save();
    ctx.globalAlpha = viz.pulseIndex;
    ctx.drawImage(viz.pulseImage, 144, 57);
    ctx.restore();
  }

  if (viz.pulseIndex >= 1) {
    viz.pulseShrink = true;
  } else if (viz.pulseIndex <= 0) {
    viz.pulseShrink = false;
  }

  if (viz.pulseShrink) viz.pulseIndex -= 0.01;
  else viz.pulseIndex += 0.01;
}

function draw(){
  clear();
  pulse();
  viz.ps.run();
}

function clear() {
  ctx.clearRect(0, 0, viz.canvasWidth, viz.canvasHeight);
}

function MouseMove(e) {

  viz.mp.x = e.layerX;
  viz.mp.y = e.layerY;
  
  viz.origin.x = viz.mp.x;
  viz.origin.y = viz.mp.y;
}
